import { Lightbulb } from 'lucide-react'

import { Button } from '~/components/ui/button.tsx'
import {
	Tooltip,
	TooltipContent,
	TooltipProvider,
	TooltipTrigger,
} from '~/components/ui/tooltip.tsx'

export function TooltipStandard({ content }: { content: string }) {
	return (
		<TooltipProvider>
			<Tooltip>
				<TooltipTrigger asChild>
					<Button
						variant="outline"
						type="button"
						className="h-8 w-8 rounded-full p-0 lg:h-6 lg:w-6"
					>
						<Lightbulb className="h-4 w-4" />
						<span className="sr-only">More Info</span>
					</Button>
				</TooltipTrigger>
				<TooltipContent className="bg-opacity-85 max-w-[400px] bg-white">
					<p>{content}</p>
				</TooltipContent>
			</Tooltip>
		</TooltipProvider>
	)
}
